import { Component, HostListener, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { forkJoin } from 'rxjs';
import { AppSettings } from '../Constant/AppSettings';
import { ClientcommunicationService } from '../services/clientcommunication/clientcommunication.service';
import { UtilsService } from '../services/utils/utils.service';
import { CommonFunctions } from '../Utilities/CommonFunctions';
import { Router } from '@angular/router';
import { ClientDataService } from '../services/client-data/client-data.service';
import { PrivilegeService } from '../services/privilege/privilege.service';

@Component({
  selector: 'app-clientcommunication',
  templateUrl: './clientcommunication.component.html',
  styleUrls: ['./clientcommunication.component.css']
})
export class ClientcommunicationComponent implements OnInit {
  items: MenuItem[] = [{ label: 'Client Communication' }];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };
  seedValue: string = '';
  clients: any[] = [];
  user: any;
  user_id: any;
  searchText = '';
  isLoading: boolean = false;
  visibleBtn: boolean = true;
  // Dialog display varaible
  displayAddModal: boolean = false;
  disabled: boolean = false;
  public innerWidth: any;

  constructor(
    public utils: UtilsService,
    private clientcommunicationService: ClientcommunicationService,
    private clientDataService: ClientDataService,
    private privilegeService: PrivilegeService,
    private router: Router,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.user = CommonFunctions.getUser();
    this.user_id = CommonFunctions.getUserId()
    this.listClient()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  /**
   * Fetches every business for the "Add Chat" picker, not just one page — pages through
   * getBusinessList() (the already-correctly-paginated endpoint used by Business Management)
   * instead of relying on getAllBusinessList()'s single request, which silently caps at whatever
   * the backend's default page size is. Doesn't depend on the backend size-param fix being deployed.
   */
  listClient() {
    this.showProgressBar();
    this.clientDataService.getBusinessList(1, '', '', null).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status != 'SUCCESS') {
          this.showErrorToastMsg(json.response.displayMessage)
          this.hideProgressBar();
          return;
        }

        const firstPage: any[] = json.data || [];
        const totalPages: number = json.additionalData?.totalPages || 1;

        if (totalPages <= 1) {
          this.clients = firstPage;
          this.hideProgressBar();
          return;
        }

        const remainingPageRequests = [];
        for (let page = 2; page <= totalPages; page++) {
          remainingPageRequests.push(this.clientDataService.getBusinessList(page, '', '', null));
        }

        forkJoin(remainingPageRequests).subscribe(
          (responses: any[]) => {
            let allClients = [...firstPage];
            responses.forEach((r: any) => {
              const pageJson = JSON.parse(JSON.stringify(r));
              if (pageJson.response.status == 'SUCCESS') {
                allClients = allClients.concat(pageJson.data || []);
              }
            });
            this.clients = allClients;
            this.hideProgressBar();
          },
          (error) => {
            console.log(error);
            // Still show what we got from page 1 rather than nothing.
            this.clients = firstPage;
            this.showErrorToastMsg(AppSettings.ERROR_MSG)
            this.hideProgressBar();
          }
        );
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  createNewChat(businessId: any) {
    this.showProgressBar()
    this.clientcommunicationService.createSupportRoomRest(businessId).subscribe((response: any) => {
      const room = response?.data;
      if (room?.id) {
        this.router.navigate(['client-communication/room/' + room.id]);
      }
      this.showHideModalDialog('add_chat')
      this.hideProgressBar()
    }, (error) => {
      console.log(error);
      this.showErrorToastMsg(AppSettings.ERROR_MSG)
      this.showHideModalDialog('add_chat')
      this.hideProgressBar()
    });
  }


  addChatRoom(client: any) {
    this.createNewChat(client.businessId)
  }


  onChangeTab(event: any) {
    console.log(event)
    if (event.index == 1) {
      this.visibleBtn = false;
    } else {
      this.visibleBtn = true;
    }
  }


  clearFormData() {
    // this.messageService.clear('errMsg');

  }

  showProgressBar() {
    this.isLoading = true;
  }

  hideProgressBar() {
    this.isLoading = false;
  }


  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }
  showErrorToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      detail: msg,
    });
  }

  showSuccessToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      detail: msg,
    });
  }

  showHideModalDialog(type: string) {
    switch (type) {
      case 'add_chat':
        this.clearFormData();
        this.displayAddModal = !this.displayAddModal;
        break;
    }
  }

  showDialogMaximized(event: any, dialog: Dialog) {
    if (this.innerWidth <= 640) {
      dialog.maximized = true;
    }

  }

  // seedData(ev: string): void {
  //   console.log(ev)
  //   this.seedValue = ev;
  // }

  getPrivilege(id: any) {
    return this.privilegeService.getPrivileges(id);
  }

  get state(): string {
    return this.utils.state;
  }
}
